import { ItemRequestAction } from '../actions/item_request_action'
import { Env } from '../../../core/env';
import { ItemRequestContainer } from '../views/pc/item_request_container';

document.addEventListener('DOMContentLoaded', () => {
    ItemRequestAction.init(Env, ItemRequestContainer);
});
